import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {UsersService} from 'src/app/modules/shared/services/users.service';
import {Constants} from 'src/app/modules/shared/config/constants.config';
import {ThemeService} from '../../../shared/services/theme.service';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Router} from '@angular/router';
import {MasterAutoDiaryGenerationConfigViewModel} from '../../../shared/viewModels/master.viewModel';
import {MasterService} from '../../../shared/services/master.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from '../../../shared/events/bsModal.events';
import {AuthService} from '../../../shared/services/auth.service';
import * as moment from 'moment/moment';

@Component({
    selector: 'app-master-auto-recipes',
    templateUrl: './auto-recipes.component.html',
    styleUrls: ['./auto-recipes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoRecipesComponent implements OnInit {
    configs: MasterAutoDiaryGenerationConfigViewModel[];

    bsModalRef: BsModalRef;
    dtOptions: {};

    constructor(
        private readonly usersService: UsersService,
        private readonly masterService: MasterService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        public readonly themeService: ThemeService,
        public readonly constants: Constants,
        public readonly router: Router,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly authService: AuthService,
    ) {
    }

    ngOnInit() {
        this.load();
    }

    load() {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 20,
            displayStart: 0, // Last Selected Page
            serverSide: false,
            processing: true,
            autoWidth: false,
            ordering: true,
            lengthMenu: ['5', '10', '20', '50', '100'],
        };

        this.masterService.getMasterAutoDiaryGenerationConfigs().subscribe(configs => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.configs = configs;
            this.changeDetectorRef.markForCheck();
        });
    }

    formatDate(date) {
        return moment(date).format('DD.MM.YYYY');
    }

    deleteConfig(id: number) {
        if (!confirm('Сигурни ли сте, че искате да изтриете тази конфигурация?')) {
            return;
        }

        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.masterService.deleteMasterAutoDiaryConfig(id)
            .subscribe(() => {
                this.load();

                this.changeDetectorRef.markForCheck();
            });
    }

    openConfig(id: number) {
        this.router.navigate(['master/auto/recipes/edit', id]);
    }
}
